module.exports = __webpack_public_path__ + "img/6.3a7e6d31.png";